import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from './Dashboard/DashboardPage';
import ProtectedRoute from '../components/ProtectedRoute';

const AdminRoutes = () => {
    return (
        <Routes>
            {/* All admin routes now render the unified DashboardPage */}
            <Route
                path="/*"
                element={
                    <ProtectedRoute allowedRoles={['ADMIN']}>
                        <DashboardPage forcedRole="ADMIN" />
                    </ProtectedRoute>
                }
            />

            {/* Redirect any unknown admin routes to dashboard */}
            <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
    );
};

export default AdminRoutes;
